import Cookies from 'js-cookie';
import CryptoJS from 'crypto-js';
import React, { useState, useEffect } from 'react';
import { Formik } from 'formik';
import Loader from '../../../../components/Loader/Loader';
import MaterialTable from 'material-table';
import useQuickBook from '../../../../hooks/useQuickBook';
import usePractice from '../../../../hooks/usePractice';
import useImport from '../../../../hooks/useImport';
import clsx from 'clsx';
import FilterListIcon from '@material-ui/icons/FilterList';
/* CSS */
import useStyles from '../../Main.style';
import Autocomplete from '@material-ui/lab/Autocomplete';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
// import MenuItem from '@material-ui/core/MenuItem';
import {
  Button,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormControlLabel,
  Slide,
  Checkbox,
  // FormControl,
  // Select,
  TextField,
  Box,
  Grid,
  Typography,
} from '@material-ui/core';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
// import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
// import ChevronRightIcon from '@material-ui/icons/ChevronRight';

const CollectionReportAll = () => {
  const classes = useStyles();
  const key = 'iFrasCwdJh';
  const { getCountry, getCountriesCells } = usePractice();
  const {
    // getAllCollectionReportDataForDisplay,
    getSelectedCellsReportDataForDisplay,
  } = useImport();
  const userCookie = Cookies.get('user');
  const bytes = CryptoJS.AES.decrypt(userCookie, key);
  const [pastDueTableObject, setPastDueTableObject] = useState([]);
  const [isDataFromImport, setIsDataFromImport] = React.useState(false);
  const [totalOverallOutstandingBalance, setTotalOverallOutstandingBalance] = React.useState(0);
  const [totalPastDueBalance, setTotalPastDueBalance] = React.useState(0);
  const [totalAccountReceivables, seTtotalAccountReceivables] = React.useState(0);
  const loggedInUserData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  console.log({ loggedInUserData });
  const [isLoaded] = useState(true);
  const { pastDueTableByCountry, pastDueTableByCell } = useQuickBook();
  const [openFilter, setOpenFilter] = React.useState(false);
  const SelectAllCountries = { countryTitle: 'Select All' };
  const [countryList, setCountryList] = useState([]);
  const [openCountry, setOpenCountry] = useState(false);
  const [show, setShow] = useState(false);
  const SelectAllCells = { cellTitle: 'Select All' };
  const [cellListForFilter, setCellListForFilter] = useState([]);
  const [selectedCellOption, setSelectedCellOption] = useState(
    loggedInUserData?.cellId
      ? [{ cellId: loggedInUserData.cellId, cellTitle: loggedInUserData.cell.cellTitle }]
      : [],
  );
  const [selectedCountryOption, setSelectedCountryOption] = useState(
    loggedInUserData?.countryId
      ? [
          {
            countryId: loggedInUserData?.countryId,
            countryTitle: loggedInUserData?.country?.countryTitle,
          },
        ]
      : [],
  );
  const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
  const checkedIcon = <CheckBoxIcon fontSize="small" />;
  const [isApplyClicked, setIsApplyClicked] = useState(false);
  const [openCountryClick, setOpenCountryClick] = React.useState(false);
  // const pageFpSizeOptions = [10, 20, 50, 100];
  const [currentFpPage /* setCurrentFpPage */] = useState(1);
  const [pageFpSize /* setFpPageSize */] = useState(50);
  const startFpIndex = (currentFpPage - 1) * pageFpSize;
  const endFpIndex = startFpIndex + pageFpSize;
  const [displayedTcData, setDisplayedTcData] = React.useState([]);
  const [collectionDataFromImport, setCollectionDataFromImport] = useState([]);
  const [selectedCells, setSelectedCells] = useState(null);

  const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
  });

  const handleColumnClick = () => {
    // Update the state to track the clicked column
    setShow(!show); // Toggle the show state
  };

  /* const handleFpPageChange = (newFpPage) => {
    setCurrentFpPage(newFpPage);
  };

  const handleFpPageSizeChange = (newFpPageSize) => {
    setFpPageSize(Number(newFpPageSize?.target?.value));
    setCurrentFpPage(1); // Reset to the first page when changing page size
  }; */

  const handleToggleOpen = (source) => {
    if (source == 'open') {
      setOpenCountry(true);
    } else if (source == 'close') {
      setOpenCountry(false);
    } else if ('changeEvent') {
      setOpenCountry(true);
    }
  };

  const loadCountries = async () => {
    const countryLists = await getCountry();
    if (countryLists.usersResult) {
      setCountryList(countryLists.usersResult);
    }
  };

  const removeButtonSelection = () => {
    const buttons = document.querySelectorAll(`[id^="button-"]`);
    buttons.forEach((button) => {
      const parentDiv = button.parentElement;
      parentDiv.classList.add(classes.TableInnerFilter);
      parentDiv.classList.remove(classes.TableInnerFilterSelect);
    });
  };

  const loadCellsForFilter = async (countryIdList) => {
    console.log('ABCD', { countryIdList });

    if (countryIdList.length > 0) {
      const CellList = await getCountriesCells(countryIdList);
      setCellListForFilter(CellList?.usersResult);
      setSelectedCellOption(CellList?.usersResult);
      return CellList.usersResult;
    } else {
      setCellListForFilter([]);
      return [];
    }
  };

  const handleClickOpenFilter = () => {
    setOpenFilter(true);
  };

  const fillPastDueTotals = async (reportObj) => {
    const tableData = [];
    const columnTotal = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    let columnTotalObj = 0;

    reportObj?.Rows?.Row.sort((ad, bd) => {
      const adVal = ad?.ColData && parseFloat(ad?.ColData[1]?.value);
      const bdVal = bd?.ColData && parseFloat(bd?.ColData[1]?.value);

      if (adVal && bdVal) {
        return bdVal - adVal;
      } else if (adVal) {
        return -1;
      } else if (bdVal) {
        return 1;
      } else {
        return 0;
      }
    }).map((c, index) => {
      if (c?.ColData) {
        if (index <= endFpIndex) {
          columnTotal[0] += parseFloat(
            c?.ColData[2]?.value === ''
              ? (0).toFixed(2).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })
              : parseFloat(c?.ColData[2]?.value).toFixed(2).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                }) || 0,
          );
          columnTotal[1] += parseFloat(
            c?.ColData[1]?.value === ''
              ? (0).toFixed(2).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })
              : parseFloat(c?.ColData[1]?.value).toFixed(2).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                }) ||
                  (0).toFixed(2).toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  }),
          );
          columnTotal[2] += parseFloat(
            c?.ColData[3]?.value === ''
              ? (0).toFixed(2).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })
              : parseFloat(c?.ColData[3]?.value).toFixed(2).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                }) ||
                  (0).toFixed(2).toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  }),
          );
          columnTotal[3] += parseFloat(
            c?.ColData[4]?.value === ''
              ? (0).toFixed(2).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })
              : parseFloat(c?.ColData[4]?.value).toFixed(2).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                }) ||
                  (0).toFixed(2).toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  }),
          );
          columnTotal[4] += parseFloat(
            c?.ColData[5]?.value === ''
              ? (0).toFixed(2).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })
              : parseFloat(c?.ColData[5]?.value).toFixed(2).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                }) ||
                  (0).toFixed(2).toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  }),
          );
          columnTotal[5] += parseFloat(
            c?.ColData[6]?.value === ''
              ? (0).toFixed(2).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })
              : parseFloat(c?.ColData[6]?.value).toFixed(2).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                }) ||
                  (0).toFixed(2).toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  }),
          );
          columnTotal[6] += parseFloat(
            c?.ColData[7]?.value === ''
              ? (0).toFixed(2).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })
              : parseFloat(c?.ColData[7]?.value).toFixed(2).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                }) ||
                  (0).toFixed(2).toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  }),
          );
          columnTotal[7] += parseFloat(
            c?.ColData[8]?.value === ''
              ? (0).toFixed(2).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })
              : parseFloat(c?.ColData[8]?.value).toFixed(2).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                }) ||
                  (0).toFixed(2).toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  }),
          );
          (columnTotal[8] =
            columnTotal[0] +
            columnTotal[2] +
            columnTotal[3] +
            columnTotal[4] +
            columnTotal[5] +
            columnTotal[6] +
            columnTotal[7]),
            (columnTotal[9] += parseFloat(
              c?.ColData[9]?.value === ''
                ? (0).toFixed(2).toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })
                : parseFloat(c?.ColData[9]?.value).toFixed(2).toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  }) ||
                    (0).toFixed(2).toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    }),
            ));
          columnTotal[10] +=
            c?.ColData[1]?.value === '' ? 0 : parseFloat(c?.ColData[1]?.value || 0);
        }

        const tableRowObj = {
          client: c?.ColData[0]?.value,
          current:
            c?.ColData[1].value === '' ? (
              'N/A'
            ) : Number(parseFloat(c?.ColData[1]?.value).toFixed(2)) < 0 ? (
              <span style={{ color: '#BF2E25' }}>
                {'(-$' +
                  Number(parseFloat(c?.ColData[1]?.value) * -1).toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  }) +
                  ')'}
              </span>
            ) : (
              '$' +
              Number(parseFloat(c?.ColData[1]?.value).toFixed(2)).toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })
            ),
          zerotofifteendays:
            c?.ColData[2].value === '' ? (
              'N/A'
            ) : Number(parseFloat(c?.ColData[2]?.value).toFixed(2)) < 0 ? (
              <span style={{ color: '#BF2E25' }}>
                {'(-$' +
                  Number(parseFloat(c?.ColData[2]?.value) * -1).toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  }) +
                  ')'}
              </span>
            ) : (
              '$' +
              Number(parseFloat(c?.ColData[2]?.value).toFixed(2)).toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })
            ),
          sixteentothirtydays:
            c?.ColData[3].value === '' ? (
              'N/A'
            ) : Number(parseFloat(c?.ColData[3]?.value).toFixed(2)) < 0 ? (
              <span style={{ color: '#BF2E25' }}>
                {'(-$' +
                  Number(parseFloat(c?.ColData[3]?.value) * -1).toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  }) +
                  ')'}
              </span>
            ) : (
              '$' +
              Number(parseFloat(c?.ColData[3]?.value).toFixed(2)).toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })
            ),

          thirtyonetofortyfivedays:
            c?.ColData[4].value === '' ? (
              'N/A'
            ) : Number(parseFloat(c?.ColData[4]?.value).toFixed(2)) < 0 ? (
              <span style={{ color: '#BF2E25' }}>
                {'(-$' +
                  Number(parseFloat(c?.ColData[4]?.value) * -1).toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  }) +
                  ')'}
              </span>
            ) : (
              '$' +
              Number(parseFloat(c?.ColData[4]?.value).toFixed(2)).toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })
            ),
          fortysixtosixtydays:
            c?.ColData[5].value === '' ? (
              'N/A'
            ) : Number(parseFloat(c?.ColData[5]?.value).toFixed(2)) < 0 ? (
              <span style={{ color: '#BF2E25' }}>
                {'(-$' +
                  Number(parseFloat(c?.ColData[5]?.value) * -1).toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  }) +
                  ')'}
              </span>
            ) : (
              '$' +
              Number(parseFloat(c?.ColData[5]?.value).toFixed(2)).toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })
            ),
          sixtyonetoseventyfivedays:
            c?.ColData[6].value === '' ? (
              'N/A'
            ) : Number(parseFloat(c?.ColData[6]?.value).toFixed(2)) < 0 ? (
              <span style={{ color: '#BF2E25' }}>
                {'(-$' +
                  Number(parseFloat(c?.ColData[6]?.value) * -1).toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  }) +
                  ')'}
              </span>
            ) : (
              '$' +
              Number(parseFloat(c?.ColData[6]?.value).toFixed(2)).toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })
            ),
          seventysixtonintydays:
            c?.ColData[7].value === '' ? (
              'N/A'
            ) : Number(parseFloat(c?.ColData[7]?.value).toFixed(2)) < 0 ? (
              <span style={{ color: '#BF2E25' }}>
                {'(-$' +
                  Number(parseFloat(c?.ColData[7]?.value) * -1).toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  }) +
                  ')'}
              </span>
            ) : (
              '$' +
              Number(parseFloat(c?.ColData[7]?.value).toFixed(2)).toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })
            ),
          morethannintyonedays:
            c?.ColData[8].value === '' ? (
              'N/A'
            ) : Number(parseFloat(c?.ColData[8]?.value).toFixed(2)) < 0 ? (
              <span style={{ color: '#BF2E25' }}>
                {'(-$' +
                  Number(parseFloat(c?.ColData[8]?.value) * -1).toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  }) +
                  ')'}
              </span>
            ) : (
              '$' +
              Number(parseFloat(c?.ColData[8]?.value).toFixed(2)).toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })
            ),
          pastduebalance:
            (
              parseFloat(c?.ColData[2].value === '' ? 0 : c?.ColData[2]?.value) +
              parseFloat(c?.ColData[3].value === '' ? 0 : c?.ColData[3]?.value) +
              parseFloat(c?.ColData[4].value === '' ? 0 : c?.ColData[4]?.value) +
              parseFloat(c?.ColData[5].value === '' ? 0 : c?.ColData[5]?.value) +
              parseFloat(c?.ColData[6].value === '' ? 0 : c?.ColData[6]?.value) +
              parseFloat(c?.ColData[7].value === '' ? 0 : c?.ColData[7]?.value) +
              parseFloat(c?.ColData[8].value === '' ? 0 : c?.ColData[8]?.value)
            ).toFixed(2) < 0 ? (
              <span style={{ color: '#BF2E25' }}>
                {'(-$' +
                  Number(
                    (
                      parseFloat(c?.ColData[2].value === '' ? 0 : c?.ColData[2]?.value) +
                      parseFloat(c?.ColData[3].value === '' ? 0 : c?.ColData[3]?.value) +
                      parseFloat(c?.ColData[4].value === '' ? 0 : c?.ColData[4]?.value) +
                      parseFloat(c?.ColData[5].value === '' ? 0 : c?.ColData[5]?.value) +
                      parseFloat(c?.ColData[6].value === '' ? 0 : c?.ColData[6]?.value) +
                      parseFloat(c?.ColData[7].value === '' ? 0 : c?.ColData[7]?.value) +
                      parseFloat(c?.ColData[8].value === '' ? 0 : c?.ColData[8]?.value)
                    ).toFixed(2) * -1,
                  ).toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  }) +
                  ')'}
              </span>
            ) : (
              '$' +
              Number(
                (
                  parseFloat(c?.ColData[2].value === '' ? 0 : c?.ColData[2]?.value) +
                  parseFloat(c?.ColData[3].value === '' ? 0 : c?.ColData[3]?.value) +
                  parseFloat(c?.ColData[4].value === '' ? 0 : c?.ColData[4]?.value) +
                  parseFloat(c?.ColData[5].value === '' ? 0 : c?.ColData[5]?.value) +
                  parseFloat(c?.ColData[6].value === '' ? 0 : c?.ColData[6]?.value) +
                  parseFloat(c?.ColData[7].value === '' ? 0 : c?.ColData[7]?.value) +
                  parseFloat(c?.ColData[8].value === '' ? 0 : c?.ColData[8]?.value)
                ).toFixed(2),
              ).toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })
            ),

          overalloutstanding:
            parseFloat(c?.ColData[9]?.value == '' ? 0 : c?.ColData[9]?.value).toFixed(2) < 0 ? (
              <span style={{ color: '#BF2E25' }}>
                {'(-$' +
                  Number(parseFloat(c?.ColData[9]?.value).toFixed(2) * -1).toLocaleString(
                    undefined,
                    {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    },
                  ) +
                  ')'}
              </span>
            ) : (
              '$' +
              Number(parseFloat(c?.ColData[9]?.value).toFixed(2)).toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })
            ),
        };

        if (pageFpSize * currentFpPage < reportObj?.Rows?.Row?.length && index == endFpIndex - 1) {
          columnTotalObj = {
            client: 'Total',
            current:
              parseFloat(columnTotal[1]).toFixed(2) == 0
                ? 'N/A'
                : '$' +
                  Number(parseFloat(columnTotal[1]).toFixed(2)).toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  }),
            zerotofifteendays:
              parseFloat(columnTotal[0]).toFixed(2) == 0
                ? 'N/A'
                : '$' +
                  Number(parseFloat(columnTotal[0]).toFixed(2)).toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  }),
            sixteentothirtydays:
              parseFloat(columnTotal[2]).toFixed(2) == 0
                ? 'N/A'
                : '$' +
                  Number(parseFloat(columnTotal[2]).toFixed(2)).toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  }),
            thirtyonetofortyfivedays:
              parseFloat(columnTotal[3]).toFixed(2) == 0
                ? 'N/A'
                : '$' +
                  Number(parseFloat(columnTotal[3]).toFixed(2)).toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  }),
            fortysixtosixtydays:
              parseFloat(columnTotal[4]).toFixed(2) == 0
                ? 'N/A'
                : '$' +
                  Number(parseFloat(columnTotal[4]).toFixed(2)).toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  }),
            sixtyonetoseventyfivedays:
              parseFloat(columnTotal[5]).toFixed(2) == 0
                ? 'N/A'
                : '$' +
                  Number(parseFloat(columnTotal[5]).toFixed(2)).toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  }),
            seventysixtonintydays:
              parseFloat(columnTotal[6]).toFixed(2) == 0
                ? 'N/A'
                : '$' +
                  Number(parseFloat(columnTotal[6]).toFixed(2)).toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  }),
            morethannintyonedays:
              parseFloat(columnTotal[7]).toFixed(2) == 0
                ? 'N/A'
                : '$' +
                  Number(parseFloat(columnTotal[7]).toFixed(2)).toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  }),
            pastduebalance:
              parseFloat(columnTotal[8]).toFixed(2) == 0
                ? 'N/A'
                : '$' +
                  Number(parseFloat(columnTotal[8]).toFixed(2)).toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  }),
            overalloutstanding:
              parseFloat(columnTotal[9]).toFixed(2) == 0
                ? 'N/A'
                : '$' +
                  Number(parseFloat(columnTotal[9]).toFixed(2)).toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  }),
          };

          tableData.push(columnTotalObj);
          tableData.push(tableRowObj);
        } else if (index == reportObj?.Rows?.Row?.length - 2) {
          columnTotalObj = {
            client: 'Total',
            current:
              parseFloat(columnTotal[1]).toFixed(2) == 0
                ? 'N/A'
                : '$' +
                  Number(parseFloat(columnTotal[1]).toFixed(2)).toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  }),
            zerotofifteendays:
              parseFloat(columnTotal[0]).toFixed(2) == 0
                ? 'N/A'
                : '$' +
                  Number(parseFloat(columnTotal[0]).toFixed(2)).toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  }),
            sixteentothirtydays:
              parseFloat(columnTotal[2]).toFixed(2) == 0
                ? 'N/A'
                : '$' +
                  Number(parseFloat(columnTotal[2]).toFixed(2)).toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  }),
            thirtyonetofortyfivedays:
              parseFloat(columnTotal[3]).toFixed(2) == 0
                ? 'N/A'
                : '$' +
                  Number(parseFloat(columnTotal[3]).toFixed(2)).toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  }),
            fortysixtosixtydays:
              parseFloat(columnTotal[4]).toFixed(2) == 0
                ? 'N/A'
                : '$' +
                  Number(parseFloat(columnTotal[4]).toFixed(2)).toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  }),
            sixtyonetoseventyfivedays:
              parseFloat(columnTotal[5]).toFixed(2) == 0
                ? 'N/A'
                : '$' +
                  Number(parseFloat(columnTotal[5]).toFixed(2)).toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  }),
            seventysixtonintydays:
              parseFloat(columnTotal[6]).toFixed(2) == 0
                ? 'N/A'
                : '$' +
                  Number(parseFloat(columnTotal[6]).toFixed(2)).toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  }),
            morethannintyonedays:
              parseFloat(columnTotal[7]).toFixed(2) == 0
                ? 'N/A'
                : '$' +
                  Number(parseFloat(columnTotal[7]).toFixed(2)).toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  }),
            pastduebalance:
              parseFloat(columnTotal[8]).toFixed(2) == 0
                ? 'N/A'
                : '$' +
                  Number(parseFloat(columnTotal[8]).toFixed(2)).toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  }),
            overalloutstanding:
              parseFloat(columnTotal[9]).toFixed(2) == 0
                ? 'N/A'
                : '$' +
                  Number(parseFloat(columnTotal[9]).toFixed(2)).toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  }),
          };
          tableData.push(tableRowObj);
          tableData.push(columnTotalObj);
        } else {
          tableData.push(tableRowObj);
        }

        parseFloat(c?.ColData[1]?.value == '' ? 0 : parseFloat(c?.ColData[1]?.value));
      }
    });

    const tableObject = {
      columns: reportObj?.Columns?.Column,
      rows: tableData,
      pastDueBalance:
        '$' +
        Number(parseFloat(columnTotal[8]).toFixed(2)).toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }),
      accountReceivable:
        '$' +
        Number(parseFloat(columnTotal[1]).toFixed(2)).toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }),
      overallOutstandingBalance: columnTotalObj?.overalloutstanding,
    };
    if (collectionDataFromImport?.length > 0) {
      setPastDueTableObject([]);
    } else {
      setPastDueTableObject(tableObject);
    }
  };

  const loadPastDueTableByCountry = async () => {
    const pastDueTableArr = await pastDueTableByCountry({ countryId: loggedInUserData?.countryId });
    fillPastDueTotals(pastDueTableArr?.reportResult);
    setSelectedCountryOption(countryList);
    const defaultCells = await loadCellsForFilter(countryList);
    setSelectedCellOption(defaultCells);
  };

  const handleCloseFilter = () => {
    setOpenFilter(false);
  };
  /* Faisal */
  /* const loadCollectionDataFromImport = async () => {
    const result = await getAllCollectionReportDataForDisplay({
      countryName: loggedInUserData?.country?.countryTitle,
    });
    if (result?.crResult && result?.crResult.length > 0) {
      createCollectionDataFromImport(result?.crResult);
      return true;
    } else {
      setCollectionDataFromImport([]);
      return false;
    }
  }; */

  const loadCollectionDataFromImportForSelectedCell = async (values) => {
    /* Faisal */
    console.log('loadCollectionDataFromImportForSelectedCell values', values);
    const result = await getSelectedCellsReportDataForDisplay({ cellValues: values });
    setIsDataFromImport(result?.fromImport);
    setTotalOverallOutstandingBalance(result?.totalOverallOutstandingBalance);
    setTotalPastDueBalance(result?.totalPastDueBalance);
    seTtotalAccountReceivables(result?.totalPastDueBalance);
    if (result?.crResult && result?.crResult.length > 0) {
      createCollectionDataFromImport(result?.crResult);
      return true;
    } else {
      setCollectionDataFromImport([]);
      return false;
    }
  };

  function formatCurrency(value) {
    if (value === null || value === undefined) {
      return 'N/A';
    }
    // Convert to a number in case it's passed as a string
    const num = Number(value);
    // Use toLocaleString to format the number with commas and fixed to 2 decimal places
    const formattedValue = Math.abs(num).toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
    // Check if the number is negative; if so, format as (-$amount), otherwise as $amount
    return num < 0 ? `(-$${formattedValue})` : `$${formattedValue}`;
  }

  const createCollectionDataFromImport = (data) => {
    const importedDataArray = [];
    const totals = {
      currentAmount: 0,
      past1to15: 0,
      past16to30: 0,
      past31to45: 0,
      past46to60: 0,
      past61to75: 0,
      past76to90: 0,
      past91: 0,
    };
    let fileterdData = [];

    const selectedCellIds = selectedCells?.split(',');
    if (selectedCellIds?.length > 0) {
      fileterdData = data.filter((item) => selectedCellIds.includes(item?.cellId.toString()));
    } else {
      fileterdData = data;
    }

    fileterdData?.forEach((item, index) => {
      const pastDueBalance =
        parseFloat(item?.past1to15 || 0) +
        parseFloat(item?.past16to30 || 0) +
        parseFloat(item?.past31to45 || 0) +
        parseFloat(item?.past46to60 || 0) +
        parseFloat(item?.past61to75 || 0) +
        parseFloat(item?.past76to90 || 0) +
        parseFloat(item?.past91 || 0);

      const overallOutstanding = parseFloat(item.currentAmount) + pastDueBalance;

      importedDataArray.push({
        client: item?.clientName,
        current: formatCurrency(item?.currentAmount),
        zerotofifteendays: formatCurrency(item?.past1to15),
        sixteentothirtydays: formatCurrency(item?.past16to30),
        thirtyonetofortyfivedays: formatCurrency(item?.past31to45),
        fortysixtosixtydays: formatCurrency(item?.past46to60),
        sixtyonetoseventyfivedays: formatCurrency(item?.past61to75),
        seventysixtonintydays: formatCurrency(item?.past76to90),
        morethannintyonedays: formatCurrency(item?.past91),
        pastduebalance: formatCurrency(pastDueBalance),
        overalloutstanding: formatCurrency(overallOutstanding),
        tableData: { id: index },
        cellId: item?.cellId,
      });

      // Update totals
      totals.currentAmount += parseFloat(item?.currentAmount || 0);
      totals.past1to15 += parseFloat(item?.past1to15 || 0);
      totals.past16to30 += parseFloat(item?.past16to30 || 0);
      totals.past31to45 += parseFloat(item?.past31to45 || 0);
      totals.past46to60 += parseFloat(item?.past46to60 || 0);
      totals.past61to75 += parseFloat(item?.past61to75 || 0);
      totals.past76to90 += parseFloat(item?.past76to90 || 0);
      totals.past91 += parseFloat(item?.past91 || 0);
    });

    // Add totals row
    importedDataArray.push({
      client: 'Total',
      current: formatCurrency(totals?.currentAmount || 0),
      zerotofifteendays: formatCurrency(totals?.past1to15 || 0),
      sixteentothirtydays: formatCurrency(totals?.past16to30 || 0),
      thirtyonetofortyfivedays: formatCurrency(totals?.past31to45 || 0),
      fortysixtosixtydays: formatCurrency(totals?.past46to60 || 0),
      sixtyonetoseventyfivedays: formatCurrency(totals?.past61to75 || 0),
      seventysixtonintydays: formatCurrency(totals?.past76to90 || 0),
      morethannintyonedays: formatCurrency(totals?.past91 || 0),
      pastduebalance: formatCurrency(
        totals.past1to15 +
          totals.past16to30 +
          totals.past31to45 +
          totals.past46to60 +
          totals.past61to75 +
          totals.past76to90 +
          totals.past91,
      ),
      overalloutstanding: formatCurrency(
        totals.currentAmount +
          totals.past1to15 +
          totals.past16to30 +
          totals.past31to45 +
          totals.past46to60 +
          totals.past61to75 +
          totals.past76to90 +
          totals.past91,
      ),
      tableData: { id: data?.length },
    });
    setPastDueTableObject({});
    setPastDueTableObject({
      accountReceivable: formatCurrency(
        totals.past1to15 +
          totals.past16to30 +
          totals.past31to45 +
          totals.past46to60 +
          totals.past61to75 +
          totals.past76to90 +
          totals.past91,
      ),
      pastDueBalance: formatCurrency(
        totals.currentAmount +
          totals.past1to15 +
          totals.past16to30 +
          totals.past31to45 +
          totals.past46to60 +
          totals.past61to75 +
          totals.past76to90 +
          totals.past91,
      ),
      overallOutstandingBalance: formatCurrency(
        totals.past1to15 +
          totals.past16to30 +
          totals.past31to45 +
          totals.past46to60 +
          totals.past61to75 +
          totals.past76to90 +
          totals.past91,
      ),
    });

    setDisplayedTcData([]);
    setDisplayedTcData(importedDataArray);
    setCollectionDataFromImport(importedDataArray);
  };
  /* useEffect(() => {
    loadCollectionDataFromImport().then((data) => {
      if (!data) loadPastDueTableByCountry();
    });
  }, [currentFpPage, pageFpSize, countryList, selectedCells]); */
  useEffect(() => {
    const initializeFilters = async () => {
      if (loggedInUserData?.countryId) {
        const defaultCountry = {
          ...loggedInUserData.country,
          countryId: loggedInUserData.countryId,
          countryTitle: loggedInUserData.country.countryTitle,
        };

        const defaultCell = {
          cellId: loggedInUserData.cellId,
          cellTitle: loggedInUserData.cell.cellTitle,
          ...loggedInUserData.cell,
        };

        // Load cells for the selected country
        const cells = await loadCellsForFilter([defaultCountry]);

        console.log('ABCD', { cells });
        // Find the default cell in the loaded cells
        const filteredCell = cells.find((cell) => cell.cellId === loggedInUserData.cellId);

        // Use filteredCell or defaultCell directly instead of selectedCellOption
        const selectedCellsForDataFetch = filteredCell ? [filteredCell] : [defaultCell];

        console.log('ABCD', { selectedCellsForDataFetch });
        // Load data for the selected cells
        const data = await loadCollectionDataFromImportForSelectedCell(selectedCellsForDataFetch);

        if (!data) {
          // If no data is returned, handle the fallback
          setCollectionDataFromImport([]);

          const cellIds = selectedCellsForDataFetch
            .filter((item) => item.qbId !== null && item.qbId !== undefined)
            .map((item) => item.qbId)
            .join(',');
          console.log('cellIds', cellIds);
          const pastDueTableArr = await pastDueTableByCell({
            cellId: cellIds,
          });

          fillPastDueTotals(pastDueTableArr?.reportResult);

          if (selectedCellsForDataFetch?.length > 0) {
            setSelectedCellOption(selectedCellsForDataFetch);
          } else {
            setSelectedCellOption([]);
          }
          console.log('ABCD', { filteredCell });
        }
      }
    };

    initializeFilters();
  }, []); // Only runs once on mount with loggedInUserData

  useEffect(() => {
    if (collectionDataFromImport?.length > 0) {
      !isApplyClicked &&
        setDisplayedTcData(collectionDataFromImport?.slice(startFpIndex, endFpIndex));
    } else {
      if (Object.keys(pastDueTableObject).length > 0) {
        setDisplayedTcData(pastDueTableObject?.rows?.slice(startFpIndex, endFpIndex));
      }
    }
  }, [pastDueTableObject, startFpIndex, endFpIndex, currentFpPage, isApplyClicked]);

  useEffect(() => {
    loadCountries();
  }, []);

  useEffect(() => {
    function handleClickOutside(event) {
      if (
        !event.target.closest('#countryAutoComplete') &&
        !event.target.closest('#country-popup') &&
        !event.target.closest('#countryAutoCompleteMob')
      ) {
        setOpenCountry(false);
        setOpenCountryClick(false);
      }
      if (event.target.closest('#countryAutoComplete')) {
        if (openCountry) {
          setOpenCountryClick(true);
        }

        if (openCountryClick && openCountry) {
          setOpenCountryClick(false);
          setOpenCountry(false);
        }
      }
    }

    // Attach the event listener on component mount
    window.addEventListener('click', handleClickOutside);

    // Clean up the event listener on component unmount
    return () => {
      window.removeEventListener('click', handleClickOutside);
    };
  }, [openCountryClick, openCountry]);

  return (
    <Box p={2}>
      <If condition={!isLoaded}>
        <Loader />
      </If>
      <If condition={isLoaded}>
        {/* Total collection COMPONENT */}

        <Grid container style={{ height: '100%' }}>
          <Grid item xs={12}>
            <Grid container direction="row">
              <Grid container>
                <Formik
                  enableReinitialize={false}
                  initialValues={{
                    countryid: [],
                    cellid: [],
                  }}
                >
                  {({ isSubmitting, setFieldValue, resetForm }) => {
                    return (
                      <>
                        <Box mt={2}>
                          <Grid container direction="row">
                            <Grid item xs={12} className={classes.FilterButtonMobile}>
                              <Box>
                                <Button
                                  startIcon={<FilterListIcon />}
                                  color="primary"
                                  onClick={handleClickOpenFilter}
                                >
                                  Filters
                                </Button>
                                <If condition={openFilter}>
                                  <Dialog
                                    fullScreen
                                    open={openFilter}
                                    onClose={handleCloseFilter}
                                    TransitionComponent={Transition}
                                  >
                                    <DialogTitle id="simple-dialog-title">
                                      <Box display="flex" justifyContent="space-between">
                                        <Box
                                          onClick={async () => {
                                            resetForm();
                                            setSelectedCells(null);
                                            setSelectedCountryOption([]);
                                            setSelectedCellOption([]);
                                            loadCollectionDataFromImportForSelectedCell([]).then(
                                              (data) => {
                                                if (!data) loadPastDueTableByCountry();
                                              },
                                            );
                                            /* loadCollectionDataFromImport().then((data) => {
                                              if (!data) loadPastDueTableByCountry();
                                            }); */
                                            removeButtonSelection();
                                          }}
                                        >
                                          Clear All
                                        </Box>
                                        <Box>
                                          <b>Filters</b>
                                        </Box>
                                        <Box onClick={handleCloseFilter}>Cancel</Box>
                                      </Box>
                                    </DialogTitle>
                                    <DialogContent>
                                      <Grid container spacing={2}>
                                        <Grid
                                          item
                                          xs={12}
                                          className={classes.FilterDropdownWidthSelectMob}
                                        >
                                          <div id="countryAutoCompleteMob">
                                            <Autocomplete
                                              multiple
                                              id="country-mob"
                                              disableCloseOnSelect
                                              options={[SelectAllCountries, ...countryList]}
                                              getOptionLabel={(option) => {
                                                return option?.countryTitle;
                                              }}
                                              onChange={(event, newValue) => {
                                                newValue?.length === 0 &&
                                                  setSelectedCountryOption(newValue);
                                              }}
                                              renderTags={() => {}}
                                              renderOption={(option) => (
                                                <React.Fragment>
                                                  {option === SelectAllCountries ? (
                                                    <FormControlLabel
                                                      control={
                                                        <Checkbox
                                                          icon={icon}
                                                          checkedIcon={checkedIcon}
                                                          style={{ marginRight: 8 }}
                                                          checked={
                                                            selectedCountryOption?.length ===
                                                            countryList?.length
                                                          }
                                                        />
                                                      }
                                                      label={option.countryTitle}
                                                      onChange={(event) => {
                                                        if (event.target.checked) {
                                                          setSelectedCountryOption(countryList);
                                                          setFieldValue(
                                                            'countryid',
                                                            countryList || [],
                                                          );
                                                          loadCellsForFilter(
                                                            selectedCountryOption || [],
                                                          );
                                                        } else {
                                                          setFieldValue('countryid', []);
                                                          setSelectedCountryOption([]);
                                                          loadCellsForFilter(
                                                            selectedCountryOption || [],
                                                          );
                                                        }
                                                      }}
                                                    />
                                                  ) : (
                                                    <FormControlLabel
                                                      control={
                                                        <Checkbox
                                                          icon={icon}
                                                          checkedIcon={checkedIcon}
                                                          style={{ marginRight: 8 }}
                                                          checked={selectedCountryOption.some(
                                                            (selectedOption) =>
                                                              selectedOption.countryTitle ===
                                                              option.countryTitle,
                                                          )}
                                                          onChange={() => {
                                                            setIsApplyClicked(false);
                                                            const isSelected = selectedCountryOption.some(
                                                              (selectedOption) =>
                                                                selectedOption.countryTitle ===
                                                                option.countryTitle,
                                                            );

                                                            let newSelectedOptions = [];

                                                            if (isSelected) {
                                                              newSelectedOptions = selectedCountryOption.filter(
                                                                (selectedOption) =>
                                                                  selectedOption.countryTitle !==
                                                                  option.countryTitle,
                                                              );
                                                            } else {
                                                              newSelectedOptions = [
                                                                ...selectedCountryOption,
                                                                option,
                                                              ];
                                                            }

                                                            setSelectedCountryOption(
                                                              newSelectedOptions,
                                                            );
                                                            setFieldValue(
                                                              'countryid',
                                                              newSelectedOptions || [],
                                                            );
                                                            loadCellsForFilter(
                                                              newSelectedOptions || [],
                                                            );
                                                          }}
                                                        />
                                                      }
                                                      label={option.countryTitle}
                                                    />
                                                  )}
                                                </React.Fragment>
                                              )}
                                              renderInput={(params) => (
                                                <TextField
                                                  {...params}
                                                  name="countryid"
                                                  variant="outlined"
                                                  label={
                                                    selectedCountryOption?.length > 1 &&
                                                    selectedCountryOption?.length <=
                                                      countryList?.length
                                                      ? 'Multiple Countries'
                                                      : selectedCountryOption?.length == 1
                                                      ? selectedCountryOption[0].countryTitle
                                                      : 'Select Country'
                                                  }
                                                />
                                              )}
                                              popupIcon={<ExpandMoreIcon />}
                                            />
                                          </div>
                                        </Grid>
                                        <Grid
                                          item
                                          xs={12}
                                          className={classes.FilterDropdownWidthSelectMob}
                                        >
                                          <Autocomplete
                                            multiple
                                            id="cells-mob"
                                            disableCloseOnSelect
                                            options={[SelectAllCells, ...cellListForFilter]}
                                            getOptionLabel={(option) => {
                                              return option?.countryDetails?.countryTitle
                                                ? option?.countryDetails?.countryTitle + ' - '
                                                : '' + option?.cellTitle;
                                            }}
                                            onChange={(event, newValue) => {
                                              newValue?.length === 0 &&
                                                setSelectedCellOption(newValue);
                                            }}
                                            renderTags={() => {}}
                                            renderOption={(option) => (
                                              <React.Fragment>
                                                {option === SelectAllCells ? (
                                                  <FormControlLabel
                                                    control={
                                                      <Checkbox
                                                        icon={icon}
                                                        checkedIcon={checkedIcon}
                                                        style={{ marginRight: 8 }}
                                                        checked={
                                                          selectedCellOption?.length ===
                                                          cellListForFilter?.length
                                                        }
                                                      />
                                                    }
                                                    label={
                                                      option?.countryDetails?.countryTitle
                                                        ? option?.countryDetails?.countryTitle +
                                                          ' - '
                                                        : '' + option?.cellTitle
                                                    }
                                                    onChange={(event) => {
                                                      if (event.target.checked) {
                                                        setSelectedCellOption(cellListForFilter);
                                                        setFieldValue(
                                                          'cellid',
                                                          cellListForFilter || [],
                                                        );
                                                      } else {
                                                        setFieldValue('cellid', []);
                                                        setSelectedCellOption([]);
                                                      }
                                                    }}
                                                  />
                                                ) : (
                                                  <FormControlLabel
                                                    control={
                                                      <Checkbox
                                                        icon={icon}
                                                        checkedIcon={checkedIcon}
                                                        style={{ marginRight: 8 }}
                                                        checked={selectedCellOption.some(
                                                          (selectedOption) =>
                                                            selectedOption.cellTitle ===
                                                            option.cellTitle,
                                                        )}
                                                        onChange={() => {
                                                          setIsApplyClicked(false);
                                                          const isSelected = selectedCellOption.some(
                                                            (selectedOption) =>
                                                              selectedOption.cellTitle ===
                                                              option.cellTitle,
                                                          );

                                                          let newSelectedOptions = [];

                                                          if (isSelected) {
                                                            newSelectedOptions = selectedCellOption.filter(
                                                              (selectedOption) =>
                                                                selectedOption.cellTitle !==
                                                                option.cellTitle,
                                                            );
                                                          } else {
                                                            newSelectedOptions = [
                                                              ...selectedCellOption,
                                                              option,
                                                            ];
                                                          }

                                                          setSelectedCellOption(newSelectedOptions);
                                                          setFieldValue(
                                                            'cellid',
                                                            newSelectedOptions || [],
                                                          );
                                                        }}
                                                      />
                                                    }
                                                    label={
                                                      option?.countryDetails?.countryTitle
                                                        ? option?.countryDetails?.countryTitle +
                                                          ' - '
                                                        : '' + option?.cellTitle
                                                    }
                                                  />
                                                )}
                                              </React.Fragment>
                                            )}
                                            renderInput={(params) => (
                                              <TextField
                                                {...params}
                                                name="cellid"
                                                variant="outlined"
                                                label={
                                                  selectedCellOption?.length > 1 &&
                                                  selectedCellOption?.length <=
                                                    cellListForFilter?.length
                                                    ? 'Multiple Cells'
                                                    : selectedCellOption?.length == 1
                                                    ? selectedCellOption[0].cellTitle
                                                    : 'Select Cell'
                                                }
                                              />
                                            )}
                                            popupIcon={<ExpandMoreIcon />}
                                          />
                                        </Grid>
                                      </Grid>
                                    </DialogContent>
                                    <DialogActions>
                                      <Button
                                        type="submit"
                                        variant="contained"
                                        color="primary"
                                        onClick={async () => {
                                          setIsApplyClicked(true);
                                          setOpenFilter(false);
                                          const response = await loadCollectionDataFromImportForSelectedCell(
                                            selectedCellOption,
                                          );

                                          if (response) {
                                            const cellIds = selectedCellOption
                                              .filter(
                                                (item) => item.id !== null && item.id !== undefined,
                                              )
                                              .map((item) => item.id)
                                              .join(',');
                                            setSelectedCells(cellIds);
                                          } else {
                                            setCollectionDataFromImport([]);
                                            const cellIds = selectedCellOption
                                              .filter(
                                                (item) =>
                                                  item.qbId !== null && item.qbId !== undefined,
                                              )
                                              .map((item) => item.qbId)
                                              .join(',');
                                            const pastDueTableArr = await pastDueTableByCell({
                                              cellId: cellIds,
                                            });
                                            fillPastDueTotals(pastDueTableArr?.reportResult);
                                          }
                                        }}
                                        fullWidth
                                      >
                                        Apply
                                      </Button>
                                    </DialogActions>
                                  </Dialog>
                                </If>
                              </Box>
                            </Grid>
                            <Grid item xs={12} className={classes.FilterDesktop}>
                              <Grid container spacing={2} className={classes.AutoCompleteDisable}>
                                <Grid item className={classes.FilterDropdownWidthSelect}>
                                  <div id="countryAutoComplete">
                                    <Autocomplete
                                      multiple
                                      id="country"
                                      open={openCountry}
                                      onOpen={() => handleToggleOpen('open')}
                                      disableCloseOnSelect
                                      options={[SelectAllCountries, ...countryList]}
                                      getOptionLabel={(option) => {
                                        return option?.countryTitle;
                                      }}
                                      onChange={(event, newValue) => {
                                        handleToggleOpen('changeEvent');
                                        newValue?.length === 0 &&
                                          setSelectedCountryOption(newValue);
                                      }}
                                      renderTags={() => {}}
                                      renderOption={(option) => (
                                        <React.Fragment>
                                          {option === SelectAllCountries ? (
                                            <FormControlLabel
                                              control={
                                                <Checkbox
                                                  icon={icon}
                                                  checkedIcon={checkedIcon}
                                                  style={{ marginRight: 8 }}
                                                  checked={
                                                    selectedCountryOption?.length ===
                                                    countryList?.length
                                                  }
                                                />
                                              }
                                              label={option.countryTitle}
                                              onChange={async (event) => {
                                                setIsApplyClicked(false);
                                                if (event.target.checked) {
                                                  setSelectedCountryOption(countryList);
                                                  setFieldValue('countryid', countryList || []);
                                                  loadCellsForFilter(countryList || []);
                                                } else {
                                                  setFieldValue('countryid', []);
                                                  setSelectedCountryOption([]);
                                                  setSelectedCellOption(
                                                    await loadCellsForFilter([]),
                                                  );
                                                }
                                              }}
                                            />
                                          ) : (
                                            <FormControlLabel
                                              control={
                                                <Checkbox
                                                  icon={icon}
                                                  checkedIcon={checkedIcon}
                                                  style={{ marginRight: 8 }}
                                                  checked={selectedCountryOption.some(
                                                    (selectedOption) =>
                                                      selectedOption.countryTitle ===
                                                      option.countryTitle,
                                                  )}
                                                  onChange={() => {
                                                    setIsApplyClicked(false);
                                                    const isSelected = selectedCountryOption.some(
                                                      (selectedOption) =>
                                                        selectedOption.countryTitle ===
                                                        option.countryTitle,
                                                    );

                                                    let newSelectedOptions = [];

                                                    if (isSelected) {
                                                      newSelectedOptions = selectedCountryOption.filter(
                                                        (selectedOption) =>
                                                          selectedOption.countryTitle !==
                                                          option.countryTitle,
                                                      );
                                                    } else {
                                                      newSelectedOptions = [
                                                        ...selectedCountryOption,
                                                        option,
                                                      ];
                                                    }

                                                    setSelectedCountryOption(newSelectedOptions);
                                                    setFieldValue(
                                                      'countryid',
                                                      newSelectedOptions || [],
                                                    );
                                                    loadCellsForFilter(newSelectedOptions || []);
                                                    setOpenCountry(true);
                                                  }}
                                                />
                                              }
                                              label={
                                                <Typography onClick={(e) => e.stopPropagation()}>
                                                  {option.countryTitle}
                                                </Typography>
                                              }
                                            />
                                          )}
                                        </React.Fragment>
                                      )}
                                      renderInput={(params) => (
                                        <TextField
                                          {...params}
                                          name="countryid"
                                          variant="outlined"
                                          label={
                                            selectedCountryOption.length > 1 &&
                                            selectedCountryOption.length <= countryList.length
                                              ? 'Multiple Countries'
                                              : selectedCountryOption.length == 1
                                              ? selectedCountryOption[0].countryTitle
                                              : 'Select Country'
                                          }
                                        />
                                      )}
                                      popupIcon={<ExpandMoreIcon />}
                                    />
                                  </div>
                                </Grid>

                                <Grid item className={classes.FilterDropdownWidthSelect}>
                                  <Autocomplete
                                    multiple
                                    id="cells"
                                    disableCloseOnSelect
                                    options={
                                      cellListForFilter && cellListForFilter.length > 0
                                        ? [SelectAllCells, ...cellListForFilter]
                                        : []
                                    }
                                    getOptionLabel={(option) => {
                                      return option?.countryDetails?.countryTitle
                                        ? option?.countryDetails?.countryTitle + ' - '
                                        : '' + option?.cellTitle;
                                    }}
                                    onChange={(event, newValue) => {
                                      newValue.length === 0 && setSelectedCellOption(newValue);
                                    }}
                                    renderTags={() => {}}
                                    renderOption={(option) => (
                                      <React.Fragment>
                                        {option === SelectAllCells ? (
                                          <FormControlLabel
                                            control={
                                              <Checkbox
                                                icon={icon}
                                                checkedIcon={checkedIcon}
                                                style={{ marginRight: 8 }}
                                                checked={
                                                  selectedCellOption.length ===
                                                  cellListForFilter.length
                                                }
                                              />
                                            }
                                            label={
                                              option?.countryDetails?.countryTitle
                                                ? option?.countryDetails?.countryTitle + ' - '
                                                : '' + option?.cellTitle
                                            }
                                            onChange={(event) => {
                                              if (event.target.checked) {
                                                setSelectedCellOption(cellListForFilter);
                                                setFieldValue('cellid', cellListForFilter || []);
                                              } else {
                                                setFieldValue('cellid', []);
                                                setSelectedCellOption([]);
                                              }
                                            }}
                                          />
                                        ) : (
                                          <>
                                            {' '}
                                            <FormControlLabel
                                              control={
                                                <Checkbox
                                                  icon={icon}
                                                  checkedIcon={checkedIcon}
                                                  style={{ marginRight: 8 }}
                                                  checked={
                                                    selectedCellOption.length ===
                                                    cellListForFilter.length
                                                      ? true
                                                      : selectedCellOption.some(
                                                          (selectedOption) =>
                                                            selectedOption.cellTitle ===
                                                            option.cellTitle,
                                                        )
                                                  }
                                                  onChange={() => {
                                                    setIsApplyClicked(false);
                                                    const isSelected = selectedCellOption.some(
                                                      (selectedOption) =>
                                                        selectedOption.cellTitle ===
                                                        option.cellTitle,
                                                    );

                                                    let newSelectedOptions = [];

                                                    if (isSelected) {
                                                      newSelectedOptions = selectedCellOption.filter(
                                                        (selectedOption) =>
                                                          selectedOption.cellTitle !==
                                                          option.cellTitle,
                                                      );
                                                    } else {
                                                      newSelectedOptions = [
                                                        ...selectedCellOption,
                                                        option,
                                                      ];
                                                    }
                                                    setSelectedCellOption(newSelectedOptions);
                                                    setFieldValue(
                                                      'cellid',
                                                      newSelectedOptions || [],
                                                    );
                                                  }}
                                                />
                                              }
                                              label={
                                                option?.countryDetails?.countryTitle +
                                                ' - ' +
                                                option?.cellTitle
                                              }
                                            />
                                          </>
                                        )}
                                      </React.Fragment>
                                    )}
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        name="cellid"
                                        variant="outlined"
                                        label={
                                          selectedCellOption.length > 1 &&
                                          selectedCellOption.length <= cellListForFilter.length
                                            ? 'Multiple Cells'
                                            : selectedCellOption.length == 1
                                            ? selectedCellOption[0].cellTitle
                                            : 'Select Cell'
                                        }
                                      />
                                    )}
                                    popupIcon={<ExpandMoreIcon />}
                                  />
                                </Grid>
                                <Grid item>
                                  <Button
                                    type="submit"
                                    className={classes.button}
                                    variant="outlined"
                                    onClick={async () => {
                                      setIsApplyClicked(true);
                                      const response = await loadCollectionDataFromImportForSelectedCell(
                                        selectedCellOption,
                                      );
                                      if (response) {
                                        const cellIds = selectedCellOption
                                          .filter(
                                            (item) => item.id !== null && item.id !== undefined,
                                          )
                                          .map((item) => item.id)
                                          .join(',');
                                        setSelectedCells(cellIds);
                                      } else {
                                        setCollectionDataFromImport([]);
                                        const cellIds = selectedCellOption
                                          .filter(
                                            (item) => item.qbId !== null && item.qbId !== undefined,
                                          )
                                          .map((item) => item.qbId)
                                          .join(',');
                                        const pastDueTableArr = await pastDueTableByCell({
                                          cellId: cellIds,
                                        });
                                        fillPastDueTotals(pastDueTableArr?.reportResult);
                                      }
                                    }}
                                  >
                                    Apply
                                  </Button>
                                  {isSubmitting && (
                                    <CircularProgress
                                      size={24}
                                      className={classes.buttonProgress}
                                    />
                                  )}
                                </Grid>
                                <Grid item>
                                  <Box
                                    display="flex"
                                    alignItems="center"
                                    height={1}
                                    className={classes.clearbtn}
                                    onClick={async () => {
                                      resetForm();
                                      setSelectedCountryOption([]);
                                      setSelectedCellOption([]);
                                      setSelectedCells(null);
                                      loadCollectionDataFromImportForSelectedCell(
                                        selectedCellOption,
                                      ).then((data) => {
                                        if (!data) loadPastDueTableByCountry();
                                      });
                                      /* loadCollectionDataFromImport().then((data) => {
                                        if (!data) loadPastDueTableByCountry();
                                      }); */
                                    }}
                                  >
                                    CLEAR
                                  </Box>
                                </Grid>
                              </Grid>
                            </Grid>
                          </Grid>
                        </Box>
                      </>
                    );
                  }}
                </Formik>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Box m={1} />
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <Box className={clsx(classes.innercontentWhite)}>
                  <Box>
                    <Box display="flex" alignItems="center" mb={2}>
                      <Box>
                        <Typography
                          variant="h5"
                          noWrap
                          className={classes.CollectionsReportSectionHeading}
                        >
                          Past Due Balance
                        </Typography>
                      </Box>
                    </Box>
                    <Box>
                      <Typography variant="h2" noWrap className={classes.CollectionsReportRedText}>
                        {isDataFromImport
                          ? '$' +
                            Number(parseFloat(totalPastDueBalance).toFixed(2)).toLocaleString(
                              undefined,
                              {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              },
                            )
                          : pastDueTableObject?.pastDueBalance || 'N/A'}
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <Box className={clsx(classes.innercontentWhite)}>
                  <Box>
                    <Box display="flex" alignItems="center" mb={2}>
                      <Box>
                        <Typography
                          variant="h5"
                          noWrap
                          className={classes.CollectionsReportSectionHeading}
                        >
                          Account Receivables
                        </Typography>
                      </Box>
                    </Box>
                    <Box>
                      <Typography
                        variant="h2"
                        noWrap
                        className={classes.CollectionsReportGreenText}
                      >
                        {isDataFromImport
                          ? '$' +
                            Number(parseFloat(totalAccountReceivables).toFixed(2)).toLocaleString(
                              undefined,
                              {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              },
                            )
                          : pastDueTableObject?.accountReceivable || 'N/A'}
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <Box className={clsx(classes.innercontentWhite)}>
                  <Box>
                    <Box display="flex" alignItems="center" mb={2}>
                      <Box>
                        <Typography
                          variant="h5"
                          noWrap
                          className={classes.CollectionsReportSectionHeading}
                        >
                          Overall Outstanding Balance
                        </Typography>
                      </Box>
                    </Box>
                    <Box>
                      <Typography
                        variant="h2"
                        noWrap
                        className={classes.CollectionsReportBlackText}
                      >
                        {isDataFromImport
                          ? '$' +
                            Number(
                              parseFloat(totalOverallOutstandingBalance).toFixed(2),
                            ).toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })
                          : pastDueTableObject?.overallOutstandingBalance || 'N/A'}
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              </Grid>

              <Grid item xs={12} className={classes.TableTotalUIAll}>
                <Box
                  className={clsx(classes.innercontentWhite, classes.CollectionsReportTableMobile)}
                >
                  <If condition={displayedTcData?.length > 0}>
                    <MaterialTable
                      style={{
                        boxShadow: 'none',
                        height: '500px',
                        overflowY: 'auto',
                      }}
                      className={classes.materialDT}
                      options={{
                        toolbar: false,
                        draggable: false,
                        paging: true,
                        sorting: false,
                        pageSize: 20,
                        pageSizeOptions: [10, 20, 50, 100],
                        showTextRowsSelected: false,
                        toolbarButtonAlignment: 'right',
                        showFirstLastPageButtons: false,
                        actionsColumnIndex: -100,
                        emptyRowsWhenPaging: false,
                        headerStyle: {
                          position: 'sticky',
                          top: 0,
                          backgroundColor: '#f5f5f5',
                          fontWeight: 'bold',
                          zIndex: 2,
                        },
                      }}
                      localization={{
                        pagination: {
                          labelRowsSelect: 'Rows',
                          labelRowsPerPage: 'Rows Per Page',
                        },
                      }}
                      title="Collections Report"
                      columns={[
                        {
                          title: (
                            <span
                              style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                              }}
                            >
                              <span>Client</span>
                              <span style={{ display: 'flex' }}>
                                <img
                                  src={
                                    show
                                      ? require('../../../../assets/images/ExpandFilled.svg')
                                          .default
                                      : require('../../../../assets/images/CollapseFilled.png')
                                          .default
                                  }
                                  onClick={() => handleColumnClick({ field: 'client' })}
                                />
                              </span>
                            </span>
                          ),
                          field: 'client',
                          render: (data) => data.client,
                          sorting: false,
                          /* cellStyle: () => {
                            return show
                              ? {
                                  maxWidth: '200px',
                                  overflow: 'hidden',
                                  textOverflow: 'ellipsis',
                                  whiteSpace: 'nowrap',
                                }
                              : {};
                          }, */
                          cellStyle: () => ({
                            ...(show
                              ? {
                                  maxWidth: '200px',
                                  overflow: 'hidden',
                                  textOverflow: 'ellipsis',
                                  whiteSpace: 'nowrap',
                                }
                              : {}),
                            ...{
                              position: 'sticky',
                              left: 0,
                              backgroundColor: '#ffffff',
                              zIndex: 1,
                            },
                          }),
                        },
                        {
                          title: <span>Current</span>,
                          field: 'current',
                          render: (data) => data.current,
                          sorting: false,
                        },
                        {
                          title: (
                            <span>
                              Past Due <br />
                              0-15 days
                            </span>
                          ),
                          field: 'zerotofifteendays',
                          render: (data) => data.zerotofifteendays,
                          sorting: false,
                        },
                        {
                          title: (
                            <span>
                              Past Due <br />
                              16-30 days
                            </span>
                          ),
                          field: 'sixteentothirtydays',
                          render: (data) => data.sixteentothirtydays,
                          sorting: false,
                        },
                        {
                          title: (
                            <span>
                              Past Due <br />
                              31-45 days
                            </span>
                          ),
                          field: 'thirtyonetofortyfivedays',
                          render: (data) => data.thirtyonetofortyfivedays,
                          sorting: false,
                        },
                        {
                          title: (
                            <span>
                              Past Due <br />
                              46-60 days
                            </span>
                          ),
                          field: 'fortysixtosixtydays',
                          render: (data) => data.fortysixtosixtydays,
                          sorting: false,
                        },
                        {
                          title: (
                            <span>
                              Past Due <br />
                              61-75 days
                            </span>
                          ),
                          field: 'sixtyonetoseventyfivedays',
                          render: (data) => data.sixtyonetoseventyfivedays,
                          sorting: false,
                        },
                        {
                          title: (
                            <span>
                              Past Due <br />
                              76-90 days
                            </span>
                          ),
                          field: 'seventysixtonintydays',
                          render: (data) => data.seventysixtonintydays,
                          sorting: false,
                        },
                        {
                          title: (
                            <span>
                              Past Due <br />
                              &lt;91
                            </span>
                          ),
                          field: 'morethannintyonedays',
                          render: (data) => data.morethannintyonedays,
                          sorting: false,
                        },
                        {
                          title: (
                            <span>
                              Past Due <br />
                              Balance
                            </span>
                          ),
                          field: 'pastduebalance',
                          render: (data) => data.pastduebalance,
                          sorting: false,
                        },
                        {
                          title: (
                            <span>
                              Overall <br />
                              Outstanding
                            </span>
                          ),
                          field: 'overalloutstanding',
                          render: (data) => data.overalloutstanding,
                          sorting: false,
                        },
                      ]}
                      data={
                        ({
                          client: 'asdf',
                          zerotofifteendays: '',
                          sixteentothirtydays: '',
                          thirtyonetofortyfivedays: '',
                          fortysixtosixtydays: '',
                          sixtyonetoseventyfivedays: '',
                          seventysixtonintydays: '',
                          morethannintyonedays: '',
                          pastduebalance: '',
                          overalloutstanding: '',
                        },
                        displayedTcData ||
                          []) /* [
                          {
                            client: 'Runflats México, S.A. de C.V.',
                            zerotofifteendays: '$2,437,830.74',
                            sixteentothirtydays: '$2,437,830.74',
                            thirtyonetofortyfivedays: '$2,437,830.74',
                            fortysixtosixtydays: '$2,437,830.74',
                            sixtyonetoseventyfivedays: '$2,437,830.74',
                            seventysixtonintydays: '$2,437,830.74',
                            morethannintyonedays: '$2,437,830.74',
                            pastduebalance: '$2,437,830.74',
                            overalloutstanding: '$2,437,830.74',
                          },
                          {
                            client: 'ALEXAR INTERNACIONAL S.A. DE C.V.',
                            zerotofifteendays: '$77,923.08',
                            sixteentothirtydays: '$77,923.08',
                            thirtyonetofortyfivedays: '$77,923.08',
                            fortysixtosixtydays: '$77,923.08',
                            sixtyonetoseventyfivedays: '$77,923.08',
                            seventysixtonintydays: 'N/A',
                            morethannintyonedays: '$77,923.08',
                            pastduebalance: '$77,923.08',
                            overalloutstanding: '$77,923.08',
                          },
                          {
                            client: 'NEMAK AUTOMOTIVE S.A. DE C.V.',
                            zerotofifteendays: 'N/A',
                            sixteentothirtydays: '$2,437,830.74',
                            thirtyonetofortyfivedays: 'N/A',
                            fortysixtosixtydays: 'N/A',
                            sixtyonetoseventyfivedays: 'N/A',
                            seventysixtonintydays: 'N/A',
                            morethannintyonedays: 'N/A',
                            pastduebalance: 'N/A',
                            overalloutstanding: 'N/A',
                          },
                          {
                            client: 'Fronius Mexico S.A de C.V.',
                            zerotofifteendays: '$84,680.33',
                            sixteentothirtydays: '$84,680.33',
                            thirtyonetofortyfivedays: '$84,680.33',
                            fortysixtosixtydays: '$84,680.33',
                            sixtyonetoseventyfivedays: '$84,680.33',
                            seventysixtonintydays: '$84,680.33',
                            morethannintyonedays: '$84,680.33',
                            pastduebalance: 'N/A',
                            overalloutstanding: '$84,680.33',
                          },
                          {
                            client: 'NEMAK MEXICO S.A. (MXN)',
                            zerotofifteendays: '$2,437,830.74',
                            sixteentothirtydays: 'N/A',
                            thirtyonetofortyfivedays: 'N/A',
                            fortysixtosixtydays: 'N/A',
                            sixtyonetoseventyfivedays: '$2,437,830.74',
                            seventysixtonintydays: 'N/A',
                            morethannintyonedays: 'N/A',
                            pastduebalance: 'N/A',
                            overalloutstanding: 'N/A',
                          },
                          {
                            client: 'ATPAK S.A. DE C.V. (USD)',
                            zerotofifteendays: '$2,437,830.74',
                            sixteentothirtydays: '$2,437,830.74',
                            thirtyonetofortyfivedays: '$2,437,830.74',
                            fortysixtosixtydays: '$2,437,830.74',
                            sixtyonetoseventyfivedays: '$2,437,830.74',
                            seventysixtonintydays: '$2,437,830.74',
                            morethannintyonedays: '$2,437,830.74',
                            pastduebalance: '$2,437,830.74',
                            overalloutstanding: '$2,437,830.74',
                          },
                          {
                            client: 'VECTOR GLOBAL LOGISTICS LLC (USD)',
                            zerotofifteendays: 'N/A',
                            sixteentothirtydays: 'N/A',
                            thirtyonetofortyfivedays: 'N/A',
                            fortysixtosixtydays: '$2,437,830.74',
                            sixtyonetoseventyfivedays: '$2,437,830.74',
                            seventysixtonintydays: 'N/A',
                            morethannintyonedays: 'N/A',
                            pastduebalance: 'N/A',
                            overalloutstanding: 'N/A',
                          },
                          {
                            client: 'NEMAK MEXICO S.A.',
                            zerotofifteendays: '$2,437,830.74',
                            sixteentothirtydays: '$77,923.08',
                            thirtyonetofortyfivedays: '$77,923.08',
                            fortysixtosixtydays: '$77,923.08',
                            sixtyonetoseventyfivedays: '$77,923.08',
                            seventysixtonintydays: '$77,923.08',
                            morethannintyonedays: '$77,923.08',
                            pastduebalance: '$77,923.08',
                            overalloutstanding: '$77,923.08',
                          },
                          {
                            client: 'Runflats México, S.A. de C.V.',
                            zerotofifteendays: 'N/A',
                            sixteentothirtydays: 'N/A',
                            thirtyonetofortyfivedays: 'N/A',
                            fortysixtosixtydays: 'N/A',
                            sixtyonetoseventyfivedays: 'N/A',
                            seventysixtonintydays: 'N/A',
                            morethannintyonedays: 'N/A',
                            pastduebalance: 'N/A',
                            overalloutstanding: 'N/A',
                          },
                          {
                            client: 'NEMAK AUTOMOTIVE S.A. DE C.V.',
                            zerotofifteendays: '$2,437,830.74',
                            sixteentothirtydays: '$2,437,830.74',
                            thirtyonetofortyfivedays: '$2,437,830.74',
                            fortysixtosixtydays: '$2,437,830.74',
                            sixtyonetoseventyfivedays: '$2,437,830.74',
                            seventysixtonintydays: '$2,437,830.74',
                            morethannintyonedays: '$2,437,830.74',
                            pastduebalance: '$2,437,830.74',
                            overalloutstanding: '$2,437,830.74',
                          },
                          {
                            client: 'ATPAK S.A. DE C.V. (USD)',
                            zerotofifteendays: 'N/A',
                            sixteentothirtydays: 'N/A',
                            thirtyonetofortyfivedays: '$2,437,830.74',
                            fortysixtosixtydays: 'N/A',
                            sixtyonetoseventyfivedays: 'N/A',
                            seventysixtonintydays: 'N/A',
                            morethannintyonedays: 'N/A',
                            pastduebalance: 'N/A',
                            overalloutstanding: 'N/A',
                          },
                          {
                            client: 'VECTOR GLOBAL LOGISTICS LLC (USD)',
                            zerotofifteendays: 'N/A',
                            sixteentothirtydays: '$2,437,830.74',
                            thirtyonetofortyfivedays: 'N/A',
                            fortysixtosixtydays: 'N/A',
                            sixtyonetoseventyfivedays: 'N/A',
                            seventysixtonintydays: 'N/A',
                            morethannintyonedays: 'N/A',
                            pastduebalance: 'N/A',
                            overalloutstanding: 'N/A',
                          },
                          {
                            client: 'ALEXAR INTERNACIONAL S.A. DE C.V.',
                            zerotofifteendays: '$77,923.08',
                            sixteentothirtydays: '$77,923.08',
                            thirtyonetofortyfivedays: '$77,923.08',
                            fortysixtosixtydays: '$77,923.08',
                            sixtyonetoseventyfivedays: '$77,923.08',
                            seventysixtonintydays: '$77,923.08',
                            morethannintyonedays: 'N/A',
                            pastduebalance: '$77,923.08',
                            overalloutstanding: '$1,637,115.06',
                          },
                          {
                            client: 'NEMAK MEXICO S.A.',
                            zerotofifteendays: '$84,680.33',
                            sixteentothirtydays: '$84,680.33',
                            thirtyonetofortyfivedays: '$84,680.33',
                            fortysixtosixtydays: 'N/A',
                            sixtyonetoseventyfivedays: '$84,680.33',
                            seventysixtonintydays: '$84,680.33',
                            morethannintyonedays: '$84,680.33',
                            pastduebalance: '$84,680.33',
                            overalloutstanding: '$2,437,830.74',
                          },
                          {
                            client: 'TOTAL',
                            zerotofifteendays: '$184,643.41',
                            sixteentothirtydays: '$184,643.41',
                            thirtyonetofortyfivedays: '$184,643.41',
                            fortysixtosixtydays: '$184,643.41',
                            sixtyonetoseventyfivedays: '$184,643.41',
                            seventysixtonintydays: '$184,643.41',
                            morethannintyonedays: '$184,643.41',
                            pastduebalance: '$184,643.41',
                            overalloutstanding: '$184,643.41',
                          },
                        ] */
                      }
                    />
                  </If>

                  <If condition={displayedTcData?.length == 0 && isApplyClicked}>
                    {selectedCountryOption?.length == 0 ? (
                      'Please select country to start.'
                    ) : (
                      <>
                        Hmmm... Sorry, past due details are not available for{' '}
                        {selectedCountryOption.map((country) => country.countryTitle).join(', ')}{' '}
                        {selectedCellOption?.length > 0 && '- '}
                        {selectedCellOption?.length > 0 &&
                          selectedCellOption.map((cell) => cell.cellTitle).join(', ')}
                        , please try different options.
                      </>
                    )}
                  </If>
                  {/*  <div className={classes.tableFooter}> */}
                  {/* <div>
                      <span style={{ marginRight: '10px' }}>Rows per page:</span>

                      <FormControl>
                        <Box>
                          <Select
                            labelId="demo-simple-select-filled-label"
                            value={pageFpSize}
                            onChange={handleFpPageSizeChange}
                            disableUnderline
                          >
                            {pageFpSizeOptions.map((size) => (
                              <MenuItem key={size} value={size}>
                                {size}
                              </MenuItem>
                            ))}
                          </Select>
                          
                        </Box>
                      </FormControl>
                    </div> */}

                  {/* <If condition={Object.keys(pastDueTableObject)?.length > 0}>
                      <div className={classes.footerArrowSection}>
                        <span>{`${startFpIndex + 1}-${
                          endFpIndex >= pastDueTableObject?.rows?.length ||
                          collectionDataFromImport?.length
                            ? pastDueTableObject?.rows?.length || collectionDataFromImport?.length
                            : endFpIndex
                        } of ${
                          pastDueTableObject?.rows?.length || collectionDataFromImport?.length
                        }`}</span>
                        <button
                          disabled={currentFpPage === 1}
                          onClick={() => handleFpPageChange(currentFpPage - 1)}
                        >
                          <ChevronLeftIcon />
                        </button>
                        <button
                          disabled={
                            endFpIndex >= pastDueTableObject?.rows?.length ||
                            collectionDataFromImport?.length
                          }
                          onClick={() => handleFpPageChange(currentFpPage + 1)}
                        >
                          <ChevronRightIcon />
                        </button>
                      </div>
                    </If> */}
                  {/* </div> */}
                </Box>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </If>
    </Box>
  );
};

export default CollectionReportAll;
